var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user--feedback_svg__clip0_61530_7224)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.25h7.5c.828 0 1.5.672 1.5 1.5v4.5c0 .828-.672 1.5-1.5 1.5h-1.817L18.634 12l-1.299-.75 1.732-3h2.683v-4.5h-7.5v4.5h2.25v1.5h-2.25c-.828 0-1.5-.672-1.5-1.5v-4.5c0-.828.672-1.5 1.5-1.5zM11.25 22.5h-1.5v-3.75A2.252 2.252 0 007.5 16.5h-3a2.252 2.252 0 00-2.25 2.25v3.75H.75v-3.75A3.754 3.754 0 014.5 15h3a3.754 3.754 0 013.75 3.75v3.75zM6 7.5A2.25 2.25 0 116 12a2.25 2.25 0 010-4.5zM6 6a3.75 3.75 0 100 7.5A3.75 3.75 0 006 6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user--feedback_svg__clip0_61530_7224"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgUserFeedback;